module.exports = __webpack_public_path__ + "static/media/correct.35bc0d7f.mp3";